<p-table [showGridlines]="true" [value]="salesOpportunitySearchResult?.Result" [paginator]="true" [rows]="searchParams ? searchParams.PageSize : 10" [lazy]="true" [totalRecords]="salesOpportunitySearchResult?.TotalCount" (onLazyLoad)="lazyLoadSalesOpportunities($event)">
  <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
    <SortAltIcon *ngIf="sortOrder === 0">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
    </SortAltIcon>
    <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
    </SortAmountUpAltIcon>
    <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
    </SortAmountDownIcon>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="ProfileID">
        {{ 'sales-opportunities.search.profile' | translate | ucfirst }}
        <p-sortIcon field="ProfileID"></p-sortIcon>
      </th>
      <th class="revenue-item-column" pSortableColumn="ItemNum">
        {{ 'sales-opportunities.search.revenue-item' | translate | ucfirst }}
        <p-sortIcon field="ItemNum"></p-sortIcon>
      </th>
      <th pSortableColumn="Probability">
        {{ 'sales-opportunities.search.probability' | translate | ucfirst }}
        <p-sortIcon field="Probability"></p-sortIcon>
      </th>
      <th class="amount-column" pSortableColumn="EstimatedAmount">
        {{ 'sales-opportunities.search.amount' | translate | ucfirst }}
        <p-sortIcon field="EstimatedAmount"></p-sortIcon>
      </th>
      <th pSortableColumn="EsitmatedClose">
        {{ 'sales-opportunities.search.estimated-close-date' | translate | titlecase }}
        <p-sortIcon field="EsitmatedClose"></p-sortIcon>
      </th>
      <th *ngIf="profileContactsTabFullAccess" class="action-column"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-salesOpp>
    <tr>
      <td>
        <a [routerLink]="'/profile/' + salesOpp.ProfileID">{{ salesOpp.Profile?.ReportName }} ({{ salesOpp.ProfileID }})</a>
      </td>
      <td class="revenue-item-column">
        {{ salesOpp.RevenueItem?.ItemName }}
      </td>
      <td>
        {{ salesOpp.SalesOpportunityProbability?.Descr }}
      </td>
      <td class="amount-column">
        <div class="mct-flex mct-row mct-justify-between mct-items-center"  >
          <span class="light-text">$</span>
          <span>
            {{ salesOpp.EstimatedAmount | currency : false : '' }}
          </span>
        </div>
      </td>
      <td>
        {{ salesOpp.EsitmatedClose | date : 'M/d/yyyy' }}
      </td>
      <td *ngIf="profileContactsTabFullAccess" class="action-column">
        <div class="mct-flex mct-row mct-justify-center mct-items-center mct-gap-6"   >
          <a class="delete-link" (click)="confirmDeletion(salesOpp)" data-cy="aWebContentDeleteItem">{{
            'sales-opportunities.search.delete' | translate | titlecase
          }}</a>
          <i class="light-grey">•</i>
          <a (click)="editDialog.open(salesOpp.SalesID)">{{ 'sales-opportunities.search.edit' | translate | titlecase }}</a>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
<p-progressSpinner *ngIf="loading"></p-progressSpinner>

<wl-sales-opportunity-edit-dialog #editDialog></wl-sales-opportunity-edit-dialog>

<p-confirmDialog
  #cd
  header="{{ 'sales-opportunities.search.delete-confirmation-header' | translate | titlecase }}"
  icon="pi pi-exclamation-triangle"
>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" (click)="cd.onReject()">{{ 'common.cancel' | translate | uppercase }}</button>
    <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="cd.onAccept()" data-cy="btnWebContentConfirmDelete">
      {{ 'web-content.search-grid.delete' | translate | uppercase }}
    </button>
  </ng-template>
</p-confirmDialog>
